import Vue from 'vue'


Vue.filter('Year', function (str) {
  let value = parseInt(str)
  if (value) {
    var d = new Date(value)
    var year = d.getFullYear()
    var month = (d.getMonth() + 1 + '').padStart(2, '0')
    var day = (d.getDate() + '').padStart(2, '0')
    var hour = d.getHours()
    var minutes = d.getMinutes()
    var seconds = d.getSeconds()
    // return hour + ':' + minutes + ':' + seconds
    return year + '-' + month + '-' + day
  } else {
    return ''
  }
})

Vue.filter('phone', function (str) {
  if (str) {
    var reg = /^(\d{3})\d*(\d{4})$/;
    return str.replace(reg, '$1****$2')
  } else {
    return ''
  }
})


Vue.filter('date', function (str) {
  let value = parseInt(str)
  if (value) {
    var d = new Date(value)
    var year = d.getFullYear()
    var month = d.getMonth() + 1
    var day = d.getDate() < 10 ? '0' + d.getDate() : '' + d.getDate()
    var hour = d.getHours()
    var minutes = d.getMinutes()
    var seconds = d.getSeconds()
    // return hour + ':' + minutes + ':' + seconds
    return year + '-' + month + '-' + day + ' ' + hour + ':' + minutes + ':' + seconds
  } else {
    return ''
  }
})

Vue.filter('dateFormate', function(originVal) {
  const dt = new Date(originVal)
  const y = dt.getFullYear()
  const m = (dt.getMonth() + 1 + '').padStart(2, '0')
  const d = (dt.getDate() + '').padStart(2, '0')
  const hh = (dt.getHours() + '').padStart(2, '0')
  const mm = (dt.getMinutes() + '').padStart(2, '0')
  const ss = (dt.getSeconds() + '').padStart(2, '0')
  return `${y}-${m}-${d} ${hh}:${mm}:${ss}`
})


Vue.filter('dates', function (str) {
  let value = parseInt(str)
  if (value) {
    var d = new Date(value*1000)
    var year = d.getFullYear()
    var month = d.getMonth() + 1
    var day = d.getDate() < 10 ? '0' + d.getDate() : '' + d.getDate()
    var hour = d.getHours()
    var minutes = d.getMinutes()
    var seconds = d.getSeconds()
    // return hour + ':' + minutes + ':' + seconds
    return year + '-' + month + '-' + day + ' ' + hour + ':' + minutes + ':' + seconds
  } else {
    return ''
  }
})

//  还款方式
Vue.filter('repayType', function (str) {
  let result;
  switch (str) {
    case 1:
      result = '银行代扣'
      break
    case 2:
      result = '融资方转账'
      break
  }
  return result
})

//  授信类型
Vue.filter('queryCredited', function (str) {
  let result;
  switch (str) {
    case 0:
      result = '银行授信-循环额度'
      break
    case 1:
      result = '银行授信-累计额度'
      break
  }
  return result
})


//  利率类型
Vue.filter('rateType', function (str) {
  let result;
  switch (str) {
    case 1:
      result = '固定利率'
      break
    case 2:
      result = '浮动利率'
      break
    case 3:
      result = '阶梯利率(按时间)'
      break
    case 4:
      result = '阶梯利率(按金额)'
      break
  }
  return result
})


//  计息方式
Vue.filter('interestType', function (str) {
  let result;
  switch (str) {
    case 1:
      result = '到期还本付息'
      break
    case 2:
      result = '前付息到期还本'
      break
  }
  return result
})


//  提前还款
Vue.filter('advanceType', function (str) {
  let result;
  switch (str) {
    case 1:
      result = '可提前还款'
      break
    case 0:
      result = '不可提前还款'
      break
  }
  return result
})


//  凭证类型
Vue.filter('docType', function (str) {
  if (!str) {
    return ''
  }
  var type = str.split(',')
  let result = '';
  for (let i = 0; i < type.length; i++) {
    result = result + typeFun(type[i])
  }
  return result
})

function typeFun(res) {
  let result;
  switch (res) {
    case '1':
      result = '银信 '
      break
    case '2':
      result = '银信流转单 '
      break
    case '3':
      result = '应收账款 '
      break
  }
  return result
}


//  服务设置 收取方式

Vue.filter('serverCollect', function (str) {
  let result;
  switch (str) {
    case 1:
      result = '资金方代扣'
      break
    case 2:
      result = '融资方缴纳'
      break
  }
  return result
})


//  服务设置  收取时点
Vue.filter('serverCollectTime', function (str) {
  let result;
  switch (str) {
    case 1:
      result = '放款时'
      break
    case 2:
      result = '还款时'
      break
  }
  return result
})


//  合同 签约方式
Vue.filter('repayType', function (str) {
  let result;
  switch (str) {
    case 1:
      result = '融资申请'
      break
    case 2:
      result = '担保审批'
      break
    case 3:
      result = '银行复审'
      break
  }
  return result
})


//  合同 订立时点
Vue.filter('contractEndTime', function (str) {
  let result;
  switch (str) {
    case 1:
      result = '融资申请'
      break
    case 2:
      result = '担保审批'
      break
    case 3:
      result = '银行复审'
      break
  }
  return result
})


//  还款方式

Vue.filter('repayType', function (str) {
  let result;
  switch (str) {
    case 1:
      result = '银行代扣'
      break
    case 2:
      result = '融资方转账'
      break
  }
  return result
})

Vue.filter('lend', function (str) {
  let result;
  switch (str) {
    case 1:
      result = '线下转账'
      break
  }
  return result
})




